import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Row } from 'antd';
import Map from './Map';
import GreyPinSvg from "../../../../assets/icons/grey-pin.svg";
import PinSvg from "../../../../assets/icons/pin.svg";
import { Marker } from "react-google-maps";
import { useMapContext } from "./map.context";

export default function MapFormItem({ value: coordinate, onChange }) {
  const [coord, setCoord] = useState();
  const { ref } = useMapContext();

  const center = useMemo(() => {
    if (!coordinate) {
      return null;
    }
    return {
      lat: coordinate.latitude,
      lng: coordinate.longitude
    }
  }, [coordinate]);

  const onMapCenterChanged = useCallback((coordinate) => {
    setCoord(coordinate);
  }, [setCoord])

  const onCancel = useCallback(() => {
    ref.map.panTo(center);
    setCoord(null);
  }, [setCoord, center]);

  const onAccept = useCallback(() => {
    onChange(coord);
    setCoord(null);
  }, [coord, setCoord, center, onChange]);

  return (
    <Col>
      <Map
        center={center}
        height="300px"
        containerElement={<Container onCancel={coord && onCancel} onAccept={coord && onAccept}/>}
        onChange={onMapCenterChanged}
      >
        {center ? (
          <Marker
            position={center}
            icon={GreyPinSvg}
          />
        ) : null}
      </Map>
    </Col>
  )
}

function Container({ children, onCancel, onAccept, ...props }) {
  return (
    <div style={{ height: '300px' }} {...props}>
      {children}
      <Col className="pin">
        <Col>
          <img src={PinSvg} width={48} height={48}/>
        </Col>
      </Col>
      {onAccept ? (
        <Row className="map-controls">
          <Button type="default" onClick={onCancel}>Cancel</Button>
          <Button type="primary" className="ml-1" onClick={onAccept}>Apply current position</Button>
        </Row>
      ) : null}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Places/components/Address/MapFormItem.js